import { render, staticRenderFns } from "./novedadesDelivery.vue?vue&type=template&id=6cc7dd38&scoped=true"
import script from "./novedadesDelivery.vue?vue&type=script&lang=js"
export * from "./novedadesDelivery.vue?vue&type=script&lang=js"
import style0 from "./novedadesDelivery.vue?vue&type=style&index=0&id=6cc7dd38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7dd38",
  null
  
)

export default component.exports